/**
 * 单镜编辑框的预填与提交映射(VID-D 顺手修,2026-08-18)。
 *
 * ★病灶(本次实测):框子**标着**「画面 / 运动描述」、**预填的是** panelMotions(动作)、
 *   **存进去的是** panelScenes(画面)—— 三方各说各话。后果不是"改了没生效",是**更坏的**:
 *   用户打开某镜、一个字没动、点保存,画面描述就被动作文案顶掉了,原文没了,还不报错。
 *   预填源必须与写入目标同一个字段,这是本文件存在的唯一理由。
 */
export interface ShotEditForm {
  /** 画面描述 → 后端写 panelScenes(线上字段名 panelPrompt,历史包袱)。 */
  panelPrompt: string;
  /** 运动/动作 → 后端写 panelMotions。 */
  panelMotion: string;
  voiceover: string;
  negativePrompt: string;
}

export const EMPTY_SHOT_EDIT_FORM: ShotEditForm = {
  panelPrompt: "",
  panelMotion: "",
  voiceover: "",
  negativePrompt: "",
};

export interface ShotTexts {
  panelScenes: string[];
  panelMotions: string[];
  voiceovers: string[];
  negativePrompts: string[];
}

/** 用第 seq 镜(1-based)的现有文案预填编辑框。缺的给空串,不给 undefined(受控组件会翻非受控)。 */
export function shotEditForm(texts: ShotTexts, seq: number): ShotEditForm {
  const i = seq - 1;
  return {
    panelPrompt: texts.panelScenes[i] ?? "",
    panelMotion: texts.panelMotions[i] ?? "",
    voiceover: texts.voiceovers[i] ?? "",
    negativePrompt: texts.negativePrompts[i] ?? "",
  };
}

/**
 * 编辑框 → 提交体:**只发真改过的字段**,没动的发 null(后端 null=不改)。
 * 全量发会把「这一镜本来就没有动作描述」写成空串,等于用空值覆盖 —— 与上面那条同族。
 */
export function shotEditPayload(form: ShotEditForm, original: ShotEditForm) {
  const diff = <K extends keyof ShotEditForm>(k: K) =>
    form[k] === original[k] ? null : form[k];
  return {
    panelPrompt: diff("panelPrompt"),
    panelMotion: diff("panelMotion"),
    voiceover: diff("voiceover"),
    negativePrompt: diff("negativePrompt"),
  };
}

/** 有没有真改动 —— 决定「保存」按钮能不能点。 */
export function shotEditDirty(form: ShotEditForm, original: ShotEditForm): boolean {
  return (Object.keys(original) as (keyof ShotEditForm)[]).some((k) => form[k] !== original[k]);
}
